<span
  class="item-navagacao-aba-leis-container"
  [ngClass]="{ ativo: item.ativa }"
>
  <span
    (click)="selecionarLei($event)"
    class="item-navagacao-aba-leis-descricao"
  >
    <span class="item-navagacao-aba-leis-titulo">{{ item.titulo }}</span>
  </span>

  <button
    *ngIf="item.ativa"
    mat-icon-button
    mat-button
    (click)="fecharLei($event)"
  >
    <mat-icon
      svgIcon="xmark-circle"
      class="material-symbols-outlined item-navegacao-aba-leis-icon-clear"
    ></mat-icon>
  </button>
</span>
